import apiClient from './apiClient';
import type { RockBTSData, RockBTSGeneral, RockBTSSpecimen } from '../types/rockBts';

export const getRockBtsData = async (workOrderDetailKey: string): Promise<RockBTSData> => {
  const r = await apiClient.get<RockBTSData>(`/workorderdetails/${workOrderDetailKey}/rockbts`);
  return r.data;
};

export const saveRockBtsData = async (
  workOrderDetailKey: string,
  general: RockBTSGeneral,
  specimens: RockBTSSpecimen[],
  confirmReset?: boolean,
): Promise<RockBTSData> => {
  const r = await apiClient.put(`/workorderdetails/${workOrderDetailKey}/rockbts`, {
    general,
    specimens,
    confirmReset,
  });
  return r.data;
};
